import { appLocalStorage } from '../../utils/misc'
import {
  LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME,
  LOCAL_STORAGE_NAVIGATION_EXPANDED_VAR_NAME
} from '../../utils/constants'

const INITIAL_STATE = {
  [LOCAL_STORAGE_NAVIGATION_EXPANDED_VAR_NAME]: false
}

const reducerMisc = (data: object, newData: object) => {
  if (newData === null) {
    appLocalStorage.removeItem(LOCAL_STORAGE_APP_CONTEXT_DATA_VAR_NAME)
    return INITIAL_STATE
  }
  return { ...data, ...newData }
}

export default reducerMisc
